import { actionItems } from './content/actionItems.js';
import { articles } from './content/articles.js';
import { categories } from './content/categories.js';
import { coaches } from './content/coaches.js';
import { collateral } from './content/collateral.js';
import { collections } from './content/collections.js';
import { lifeEvents } from './content/lifeEvents.js';
import { media } from './content/media.js';
import { milestones } from './content/milestones.js';
import { pages } from './content/pages.js';
import { snippets } from './content/snippets.js';
import { tags } from './content/tags.js';
import { featuredContent } from './content/featuredContent.js';
export const contentTypes = [
    actionItems,
    articles,
    categories,
    coaches,
    collateral,
    collections,
    lifeEvents,
    media,
    milestones,
    pages,
    snippets,
    tags,
    featuredContent,
];
//# sourceMappingURL=contentTypes.js.map